import { Component, OnInit, Inject, Input } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { TranslateService } from "@ngx-translate/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-history-module",
  templateUrl: "./history-module.component.html",
  standalone: false,
})
export class HistoryModuleComponent implements OnInit {
  changes: any[] = [];

  @Input() data;
  constructor(
    private translateService: TranslateService,
    private sanitizer: DomSanitizer,
    public activeModal: NgbActiveModal
  ) {
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
  }

  ngOnInit() {
    this.compareData();
  }

  onNoClick(): void {
    this.activeModal.close(false); // close modal (value not used here)
  }

  compareData() {
    this.changes = [];
    for (let i = 0; i < this.data.response.length - 1; i++) {
      let changes: any = {};
      let keys = [
        "name",
        "hint",
        "tooltipCSS",
        "position",
        "hintPosition",
        "element",
        "elementSelector",
      ];
      if (this.data.type == "faq") {
        keys = ["question", "answer"];
      }
      if (this.data.type == "userguide") {
        keys = ["text", "name"];
      }
      if (this.data.type == "workflow") {
        keys = [
          "name",
          "elementSelector",
          "triggerElement",
          "showOn",
          "feedback",
        ];

        if (
          this.data.response[i].workflowSteps &&
          this.data.response[i + 1].workflowSteps
        ) {
          let workflowStepsChanges: any[] = [];
          for (let j = 0; j < this.data.response[i].workflowSteps.length; j++) {
            let stepChanges: any = {};
            let stepKeys = [
              "element",
              "displayStep",
              "intro",
              "name",
              "workflowStepType",
              "nextPageUrl",
            ];
            stepKeys.forEach((key) => {
              if (
                this.data.response[i].workflowSteps[j][key] !==
                this.data.response[i + 1].workflowSteps[j][key]
              ) {
                stepChanges[key] = {
                  newValue: this.data.response[i].workflowSteps[j][key],
                  oldValue: this.data.response[i + 1].workflowSteps[j][key],
                  name: this.data.response[i + 1].workflowSteps[j].name,
                };
              }
            });
            if (Object.keys(stepChanges).length > 0) {
              workflowStepsChanges.push({
                index: j,
                changes: stepChanges,
                updatedAt: this.data.response[i].workflowSteps[j].updatedAt,
              });
            }
          }
          if (workflowStepsChanges.length > 0) {
            changes.workflowSteps = workflowStepsChanges;
          }
        }
      }
      keys.forEach((key) => {
        if (this.data.response[i][key] !== this.data.response[i + 1][key]) {
          changes[key] = {
            newValue: this.data.response[i][key],
            oldValue: this.data.response[i + 1][key],
          };
        }
      });
      if (Object.keys(changes).length > 0) {
        this.changes.push({
          index: i,
          changes: changes,
          updatedAt: this.data.response[i].updatedAt,
        });
      }
    }
  }

  isHtmlField(key: string): boolean {
    const htmlFields = ["hint", "text", "answer", "intro"];
    return htmlFields.includes(key);
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
